import { useState } from 'react';
import { Grid2 as Grid } from '@mui/material';
import { DateTimePicker, DateTimeValidationError, PickerChangeHandlerContext } from '@mui/x-date-pickers';

const DateRangeFilter = ({
  onDateRangeChange,
}: {
  onDateRangeChange: (startDate: Date | null, endDate: Date | null) => void;
}) => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleStartDateChange = (
    newDate: Date | null,
    context: PickerChangeHandlerContext<DateTimeValidationError>
  ) => {
    setStartDate(newDate);
    if (!context.validationError) {
      onDateRangeChange(newDate, endDate);
    }
  };

  const handleEndDateChange = (newDate: Date | null, context: PickerChangeHandlerContext<DateTimeValidationError>) => {
    setEndDate(newDate);
    if (!context.validationError) {
      onDateRangeChange(startDate, newDate);
    }
  };

  return (
    <>
      <Grid>
        <DateTimePicker label="Start date" value={startDate} onChange={handleStartDateChange} />
      </Grid>
      <Grid>
        <DateTimePicker label="End date" value={endDate} onChange={handleEndDateChange} />
      </Grid>
    </>
  );
};

export default DateRangeFilter;
